var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 28.5,
    stroke: "#003057",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7428 30.4041C19.9618 29.6231 18.6954 29.6231 17.9144 30.4041C17.1334 31.1852 17.1334 32.4515 17.9144 33.2326L20.7428 30.4041ZM22.2962 37.6144L23.7104 39.0286L26.5388 36.2002L25.1246 34.7859L22.2962 37.6144ZM17.9144 33.2326L22.2962 37.6144L25.1246 34.7859L20.7428 30.4041L17.9144 33.2326Z",
    fill: "#003057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3517 24.0431C45.1328 23.2621 45.1328 21.9957 44.3517 21.2147C43.5707 20.4336 42.3043 20.4336 41.5233 21.2147L44.3517 24.0431ZM25.1244 37.6135L23.7102 39.0278L26.5387 41.8562L27.9529 40.442L25.1244 37.6135ZM41.5233 21.2147L25.1244 37.6135L27.9529 40.442L44.3517 24.0431L41.5233 21.2147Z",
    fill: "#003057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmIcon);
export default __webpack_public_path__ + "static/media/confirm-icon.e2e85dcd9abd2fd7ed82d195003d7142.svg";
export { ForwardRef as ReactComponent };